<template>
    <div class="text-sm sm:text-xl time-inputs text-neutral-400">
        <div class="time-input-group">
            <input
                class="focus:outline-[#F06906] rounded-full bg-neutral-800 text-neutral-400   px-[9.38px] py-[6.25px] sm:px-[15px] sm:py-[10px]"
                type="text" v-model="formattedStartTime" @keyup.enter="handleStartTimeSubmit"
                @blur="handleStartTimeSubmit">
            <span>to</span>
            <input
                class=" focus:outline-[#F06906] rounded-full bg-neutral-800 text-neutral-400  px-[9.38px] py-[6.25px]  sm:px-[15px] sm:py-[10px]"
                type="text" v-model="formattedEndTime" @keyup.enter="handleEndTimeSubmit" @blur="handleEndTimeSubmit">
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed, ref, watch } from 'vue'
import { useVideoEditorStore } from './store'
import { formatTime } from './utils'

const store = useVideoEditorStore()
const startTimeInput = ref('')
const endTimeInput = ref('')

// 监听 store 中的时间变化，同步到输入框
watch(() => store.startTime, (newTime) => {
    startTimeInput.value = formatTime(newTime)
}, { immediate: true })

watch(() => store.endTime, (newTime) => {
    endTimeInput.value = formatTime(newTime)
}, { immediate: true })

const formattedStartTime = computed({
    get: () => startTimeInput.value,
    set: (value) => startTimeInput.value = value
})

const formattedEndTime = computed({
    get: () => endTimeInput.value,
    set: (value) => endTimeInput.value = value
})

// 处理时间输入
const handleStartTimeInput = (timeStr: string) => {
    const [hours, minutes, seconds] = timeStr.split(':').map(str => parseInt(str) || 0)
    const newTime = (hours * 3600 + minutes * 60 + seconds) * 1000000

    // 开始时间不能大于结束时间
    if (newTime > store.endTime) {
        return
    }
    store.setTimeRange(newTime, store.endTime)
}

const handleEndTimeInput = (timeStr: string) => {
    const [hours, minutes, seconds] = timeStr.split(':').map(str => parseInt(str) || 0)
    const newTime = (hours * 3600 + minutes * 60 + seconds) * 1000000


    // 结束时间不能小于开始时间
    if (newTime < store.startTime) {
        return
    }
    // 结束时间如果大于视频总时长，则设置为视频总时长
    if (newTime > store.duration) {
        store.setTimeRange(store.startTime, store.duration)
        return
    }

    store.setTimeRange(store.startTime, newTime)
}

const handleStartTimeSubmit = () => {
    handleStartTimeInput(startTimeInput.value)
}

const handleEndTimeSubmit = () => {
    handleEndTimeInput(endTimeInput.value)
}
</script>

<style lang="scss" scoped>
.time-input-group {
    display: flex;
    align-items: center;
    gap: 6.25px;
    
    @media (min-width: 640px) {
        gap: 10px;
    }

    input {
        width: 80px;
        @media (min-width: 640px) {
            width: 114px;
        }
    }
}
</style>
